<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / IHRE BERECHNUNGEN
      </div>
      <h2 class="dlg__title">Ihre Zusatzversicherungs-Berechnungen</h2>
      <p class="dlg__sub">
        Übersicht aller bisher durchgeführten Berechnungen mit den jeweils
        besten Empfehlungen.
      </p>
    </header>

    <div class="dlg__note dlg__note--info ab-newcalc">
      <v-icon icon="mdi-plus-circle-outline" size="16" />
      <span>
        Eine neue Berechnung starten?
        <router-link
          @click="berechnungStore.closePop(berechnungStore.tarif)"
          :to="`/start/${guestStore.guest.guest_user_id}`"
          class="dlg__link"
        >
          Hier klicken →
        </router-link>
      </span>
    </div>

    <div v-if="berechnungen" class="ab-list">
      <article v-for="b in berechnungen" :key="b.ber_id" class="ab-item">
        <header class="ab-item__head">
          <div class="ab-item__title">
            <span
              class="ab-item__segment"
              :style="{ backgroundColor: b.segmentColor || '#0f4c81' }"
            >
              {{ b.showBerechnungName }}
            </span>
            <span class="ab-item__person">
              {{ b.show_ber_geschlecht }} · {{ b.show_ber_geburtstag }}
            </span>
          </div>
          <div class="ab-item__id">Nr. {{ b.ber_id }}</div>
        </header>

        <div class="ab-item__body">
          <div class="ab-item__main">
            <article class="ab-rec">
              <div class="ab-rec__head">
                <v-icon icon="mdi-star" size="14" color="success" />
                <span class="ab-rec__eyebrow">Empfehlung beste Leistung</span>
              </div>
              <div class="ab-rec__name">{{ b.ber_best_emp }}</div>
              <div class="ab-rec__price">{{ b.ber_best_emp_preis }}&nbsp;€</div>
              <router-link
                @click="berechnungStore.closePopApp"
                :to="`/angebot/kostenlos/${b.ber_beste_leistung_tarif_id}/${b.ber_identity_token}`"
                class="dlg__btn ab-rec__cta"
              >
                Antrag &amp; Infopaket
              </router-link>
            </article>

            <article v-if="b.ber_alt_emp" class="ab-rec">
              <div class="ab-rec__head">
                <v-icon icon="mdi-star-outline" size="14" color="success" />
                <span class="ab-rec__eyebrow">
                  Sehr gute Alternative
                </span>
              </div>
              <template v-if="b.ber_kunden_id == 0">
                <div class="ab-rec__name">{{ b.ber_alt_emp }}</div>
                <div class="ab-rec__price">{{ b.ber_alt_emp_preis }}&nbsp;€</div>
                <router-link
                  @click="berechnungStore.closePopApp"
                  :to="`/angebot/kostenlos/${b.ber_beste_alternative_tarif_id}/${b.ber_identity_token}`"
                  class="dlg__btn dlg__btn--ghost ab-rec__cta"
                >
                  Antrag &amp; Infopaket
                </router-link>
              </template>
              <div v-else class="dlg__note dlg__note--ok ab-claimed">
                <v-icon icon="mdi-check-circle-outline" size="16" />
                <span>
                  Sie haben für diese Berechnung bereits ein Antrag &amp;
                  Infopaket angefordert.
                </span>
              </div>
            </article>
          </div>

          <aside class="ab-item__side">
            <div class="dlg__kpi-label">Berechnungsvorgaben</div>
            <ul class="ab-side__list">
              <li
                v-for="(item, index) in b.berlog"
                :key="index"
                v-html="nl2br(item.value)"
              ></li>
            </ul>
          </aside>
        </div>

        <footer v-if="b.ber_kunden_id == 0" class="ab-item__foot">
          <router-link
            @click="berechnungStore.closePopApp"
            :to="`/vergleich/ergebnis/${b.ber_identity_token}`"
            class="dlg__btn dlg__btn--ghost"
          >
            <v-icon icon="mdi-open-in-new" size="14" class="mr-1" />
            Diese Berechnung öffnen
          </router-link>
        </footer>
      </article>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref } from "vue";
  import BaseCalls from "@/services/BaseCalls";
  import { useBerechnungStore } from "@/stores/berechnung";
  import { useLoaderStore } from "@/stores/loaderStore";
  import { useGuestStore } from "@/stores/guest";
  import { useNl2Br } from "@/composable/useNl2Br";

  const { nl2br } = useNl2Br();
  const loaderStore = useLoaderStore();
  const guestStore = useGuestStore();
  const berechnungStore = useBerechnungStore();

  const berechnungen = ref(false);

  function setLoading(loading) {
    loaderStore.setLoader(loading);
  }
  async function getBerechnungen() {
    let berSelect = {};
    berSelect.action = "getAllUserBerechnungen";
    setLoading(true);
    try {
      const resp = await BaseCalls.postBerechnung(berSelect);
      if (resp.data && resp.data.berechnungen) {
        berechnungen.value = resp.data.berechnungen;
        setLoading(false);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  onMounted(() => {
    getBerechnungen();
  });
</script>

<style scoped>
  .ab-newcalc {
    margin-bottom: 14px;
  }
  .ab-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .ab-item {
    background: #ffffff;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    overflow: hidden;
  }
  .ab-item__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 14px;
    background: #fafbfd;
    border-bottom: 1px solid #eef1f6;
  }
  .ab-item__title {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .ab-item__segment {
    display: inline-block;
    padding: 2px 8px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    border-radius: 2px;
  }
  .ab-item__person {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
  }
  .ab-item__id {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #6b7280;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }

  .ab-item__body {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px 14px;
  }
  @media (min-width: 720px) {
    .ab-item__body {
      grid-template-columns: minmax(0, 1fr) 240px;
    }
  }
  .ab-item__main {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
  @media (min-width: 600px) {
    .ab-item__main {
      grid-template-columns: 1fr 1fr;
    }
  }

  .ab-rec {
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .ab-rec__head {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .ab-rec__eyebrow {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #2e7d32;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }
  .ab-rec__name {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
  }
  .ab-rec__price {
    font-size: 17px;
    font-weight: 800;
    color: #0f4c81;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.3px;
  }
  .ab-rec__cta {
    align-self: flex-start;
    margin-top: 4px;
  }
  .ab-claimed {
    margin: 0;
  }

  .ab-item__side {
    background: #fafbfd;
    border: 1px solid #eef1f6;
    border-radius: 3px;
    padding: 10px 12px;
  }
  .ab-side__list {
    list-style: none;
    margin: 4px 0 0;
    padding: 0;
    font-size: 12.5px;
    color: #1f2937;
  }
  .ab-side__list li {
    padding: 1px 0;
  }

  .ab-item__foot {
    display: flex;
    justify-content: flex-end;
    padding: 8px 14px 12px;
    border-top: 1px solid #eef1f6;
  }
</style>
